import { createSharedComposable, useState, useSharedBroadcast } from '#imports'
import { type BroadcastMessage, BroadcastMessageType } from '../types'

export const usePlaygameConnectionState = createSharedComposable(() => {
    const { onMessage } = useSharedBroadcast()

    const connected = useState('playgameConnected', () => false)

    const handleBroadcastMessage = (event: BroadcastMessage) => {
        if (event.type === BroadcastMessageType.PLAYGAME_CONNECTED) connected.value = true
        if (event.type === BroadcastMessageType.PLAYGAME_DISCONNECTED) connected.value = false
    }

    onMessage(handleBroadcastMessage)

    return { connected }
})
